import { useServerTimeSync } from '@exam-center/server-time';
import type { PropsWithOptionalChildren } from '@shared/utils';

type BaseLayoutProps = PropsWithOptionalChildren;

export function ServerTimeLayout(props: Readonly<BaseLayoutProps>) {
  const { children } = props;

  useServerTimeSync();

  return children;
}
